import { BoxIcon } from 'components/icons';

/** Placeholder shown when a list / collection has no items. */
export function EmptyState({ icon: IconComponent = BoxIcon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-surface-100 text-slate-400">
        <IconComponent className="h-7 w-7" />
      </span>
      <div>
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
        {description && <p className="mt-1 max-w-md text-sm text-slate-500">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export default EmptyState;
